import { configureStore } from "@reduxjs/toolkit";
import messageSlice from "src/redux/slices/message";
import userSlice from "src/redux/slices/user";

const store = configureStore({
  reducer: {
    messages: messageSlice,
    user: userSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
